import StarterpackListWrap from './StarterpackListWrap';
export default StarterpackListWrap;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackList/index.ts